"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEGATIVE_UNL_ID = void 0;
exports.NEGATIVE_UNL_ID = '2E8A59AA9D3B5B186B0B9E0F62E6C02587CA74A4D778938E957B6357D364B244';
//# sourceMappingURL=NegativeUNL.js.map